import React from "react";
import {
  ListItemButton as MuiListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { styled } from "@mui/material/styles";

interface IListItemButtonProps {
  label?: string;
  onClick?: () => void;
  enableRightArrow?: boolean;
  rightArrowRotate?: string;
  icon?: React.ReactNode;
  isActive?: boolean;
  isNested?: boolean;
}

const StyledListItemButton = styled(MuiListItemButton, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'isNested',
})<{ isActive?: boolean; isNested?: boolean }>(({ isActive, isNested }) => ({
  borderRadius: "12px",
  marginBottom: "4px",
  padding: isNested ? "10px 16px" : "12px 16px",
  backgroundColor: isActive 
    ? "rgba(47, 128, 237, 0.25)" 
    : "rgba(255, 255, 255, 0.05)",
  borderLeft: isActive ? "3px solid #2F80ED" : "3px solid transparent",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: isActive 
      ? "rgba(47, 128, 237, 0.35)" 
      : "rgba(255, 255, 255, 0.12)",
    transform: "translateX(4px)",
    borderLeft: "3px solid rgba(255, 255, 255, 0.3)",
  },
  "& .MuiListItemIcon-root": {
    minWidth: isNested ? 36 : 40,
    color: isActive ? "#2F80ED" : "rgba(255, 255, 255, 0.85)",
    transition: "color 0.3s ease",
  },
  "& .MuiListItemText-primary": {
    fontWeight: isActive ? 600 : 500,
    fontSize: isNested ? "14px" : "15px",
    color: isActive ? "#FFFFFF" : "rgba(255, 255, 255, 0.9)",
    letterSpacing: "0.2px",
    transition: "all 0.3s ease",
  },
}));

const ListItemButton: React.FC<IListItemButtonProps> = ({
  label,
  onClick,
  enableRightArrow,
  rightArrowRotate,
  icon,
  isActive,
  isNested,
}) => {
  return (
    <StyledListItemButton
      onClick={onClick}
      isActive={isActive}
      isNested={isNested}
    >
      {icon && (
        <ListItemIcon>
          {icon}
        </ListItemIcon>
      )}
      <ListItemText primary={label} />
      {enableRightArrow && (
        <ArrowRightIcon 
          sx={{ 
            rotate: rightArrowRotate,
            transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            fontSize: "20px",
            color: "rgba(255, 255, 255, 0.7)",
          }} 
        />
      )}
    </StyledListItemButton>
  );
};

export default ListItemButton;
